module.exports = __webpack_public_path__ + "img/crop.ebc25269.svg";